import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
  getReportSuccessAction,
  getReportFailureAction,
  getDropDownSuccessAction,
  getDropDownFailureAction,
  getExportFileSuccessAction,
  getExportFileFailureAction,
  getIndividualReportSuccessAction,
  getIndividualReportFailureAction
} from '../../features/Reports/externalCandidateReportSlice';
import URLs from '../../../constants/urls';
import { GET_REPORT_TABLE_DATA, GET_REPORT_DROP_DOWN, GET_EXPORT_FILE, GET_REPORT } from '../../actions/Reports/actionTypes';
import { apiPython } from '../../../service/api';
const api = apiPython;
import { getSessionStorage } from '../../../utils/helpers';
export function* getDropDownListSaga() {
  try {
    const response = yield api.get(`${URLs.GET_EXTERNAL_CANDIDATE_REPORT}?assessmentcycleID=0`);
    const data = response.data.data;
    const default130 = data.cycleList.filter((item) => item.assessmentCycleName.includes('130'));
    const response2 = yield api.get(
      `${URLs.GET_EXTERNAL_CANDIDATE_REPORT}?assessmentcycleID=${default130[0].id}&assessmentCycleName=${default130[0].assessmentCycleName}`
    );
    yield put(getDropDownSuccessAction(response2.data.data));
  } catch (error) {
    yield put(getReportFailureAction(error));
  }
}
export function* getExternalCandidateReportListSaga({ payload: data }) {
  try {
    const response = yield api.get(
      `${URLs.GET_EXTERNAL_CANDIDATE_REPORT}?assessmentcycleID=${data['assessmentcycleID']}&assessmentCycleName=${data['assessmentCycleName']}`
    );
    yield put(getReportSuccessAction(response.data.data));
  } catch (error) {
    yield put(getDropDownFailureAction(error));
  }
}
export function* getExportFileSaga({ payload: data }) {
  try {
    const response = yield api.get(
      `${URLs.GET_EXPORT_FILE}?assessmentcycleID=${data['assessmentcycleID']}&loggedUserID=${getSessionStorage(
        'USER_ID'
      )}&assessmentCycleName=${data['assessmentCycleName']}`
    );
    yield put(getExportFileSuccessAction(response.data.data));
  } catch (error) {
    yield put(getExportFileFailureAction(error));
  }
}

export function* getIndividualReportSaga({ payload: data }) {
  try {
    if (data['title'] === 'selfCandidate') {
      const response = yield api.get(`${URLs.GET_SELF_REPORT}?responseid=${data['responseid']}`);
      yield put(getIndividualReportSuccessAction(response.data.data));
    } else {
      const response = yield api.get(`${URLs.GET_EXTERNAL_REPORT}?responseid=${data['responseid']}`);
      yield put(getIndividualReportSuccessAction(response.data.data));
    }
  } catch (error) {
    yield put(getIndividualReportFailureAction(error));
  }
}
export function* watchExternalReport() {
  yield takeEvery(GET_REPORT_DROP_DOWN, getDropDownListSaga);
  yield takeEvery(GET_EXPORT_FILE, getExportFileSaga);
  yield takeEvery(GET_REPORT_TABLE_DATA, getExternalCandidateReportListSaga);
  yield takeEvery(GET_REPORT, getIndividualReportSaga);
}

export default function* externalCandidateReportsSaga() {
  yield all([watchExternalReport()]);
}
